var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatDiaryNewCycleEntry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff4a4a;}.cls-2{fill:#fff;}.cls-3{fill:#ff9f92;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heat_cycle_view_entries"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 299.98,
    cy: 301.94,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.55,370.19c-23.66,0-42.91-18-42.91-40.1V154.34c0-22.12,19.25-40.11,42.91-40.11H319c23.66,0,42.91,18,42.91,40.11V330.09c0,22.11-19.25,40.1-42.91,40.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319,129.23c15.42,0,27.91,11.24,27.91,25.11V330.09c0,13.87-12.49,25.1-27.91,25.1H123.55c-15.41,0-27.91-11.23-27.91-25.1V154.34c0-13.87,12.5-25.11,27.91-25.11H319m0-30H123.55c-31.93,0-57.91,24.72-57.91,55.11V330.09c0,30.38,26,55.1,57.91,55.1H319c31.93,0,57.91-24.72,57.91-55.1V154.34c0-30.39-26-55.11-57.91-55.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.55,129.23c-15.41,0-27.91,11.3-27.91,25.11V192H346.87V154.34c0-13.81-12.49-25.11-27.91-25.11H123.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.85,104.13a12.55,12.55,0,0,0-12.55,12.55v37.66a12.56,12.56,0,0,0,25.11,0V116.68A12.55,12.55,0,0,0,140.85,104.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M298.21,104.13a12.19,12.19,0,0,0-12.56,12.55v37.66c0,6.28,5.63,12.55,12.56,12.55s12.55-6.27,12.55-12.55V116.68A12.18,12.18,0,0,0,298.21,104.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.94,525.46a58.33,58.33,0,0,1-58.26-58.26V420H263.32a56.8,56.8,0,1,1,0-113.6h48.36V259.36a58.26,58.26,0,0,1,116.52,0v47.08h56.16a56.8,56.8,0,0,1,0,113.6H428.2V467.2A58.33,58.33,0,0,1,369.94,525.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.94,216.1a43.39,43.39,0,0,1,43.26,43.26v62.08h71.16a41.8,41.8,0,0,1,0,83.6H413.2V467.2a43.39,43.39,0,0,1-43.26,43.26h0a43.39,43.39,0,0,1-43.26-43.26V405H263.32a41.8,41.8,0,1,1,0-83.6h63.36V259.36a43.39,43.39,0,0,1,43.26-43.26h0m0-30a73.34,73.34,0,0,0-73.26,73.26v32.08H263.32a71.8,71.8,0,1,0,0,143.6h33.36V467.2a73.26,73.26,0,1,0,146.52,0V435h41.16a71.8,71.8,0,0,0,0-143.6H443.2V259.36a73.34,73.34,0,0,0-73.26-73.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatDiaryNewCycleEntry);
export default __webpack_public_path__ + "static/media/heat_diary_new_cycle_entry.a496cb2668e1426858ebd51700dae36d.svg";
export { ForwardRef as ReactComponent };